// NOTE: NSAI-6791 — what the content of a pasted-text card looks like, which
// picks the card's icon and label and, in the editor, whether long lines wrap.
export enum EPastedTextKind {
  CODE = "code",
  JSON = "json",
  MARKDOWN = "markdown",
  TEXT = "text",
}

// NOTE: NSAI-6791 — a long paste held beside the draft instead of inside it.
// The content is the whole paste, verbatim (line endings normalised to "\n"),
// and it is what is sent; the card only ever shows a summary of it.
export interface IPastedText {
  id: string;
  content: string;
}

export interface IPastedTextSummary {
  kind: EPastedTextKind;
  lineCount: number;
  characterCount: number;
  snippet: string;
}
